import { defineStore } from "pinia";
import { getCustomerPublicData } from "@/lib/api";
import { getCompany } from "@/lib/utilities";

export const customer = defineStore("customer", {
  state: () => ({
    customerInformation: {},
    customerError: null
  }),
  getters: {
    getCompany() {
      return (pluses) => {
        let company;
        try {
          //get it from localstorage if we can
          company = getCompany(pluses);
          if (!company) throw new Error();
        } catch {
          company = pluses
            ? this.customerInformation.tradingName?.replaceAll(" ", "+")
            : this.customerInformation.tradingName;
        }
        return company?.replaceAll(/[()]/g, "");
      };
    },
    getCustomerCountryCode() {
      return this.customerInformation?.customerAddressDetails?.countryIdentifier?.isoCountryCode;
    },
    getCustomerCountryName() {
      return this.customerInformation?.customerAddressDetails?.countryIdentifier?.isoCountryFullName;
    },
    getCustomerCodeCMD() {
      return this.customerInformation?.customerCodes?.customerCode;
    }
  },

  actions: {
    async getCustomerInfo() {
      try {
        const customerData = await getCustomerPublicData();
        this.customerInformation = customerData?.[0];
      } catch (e) {
        this.customerError = e;
      }
    }
  }
});
